import {
  MODE_OF_TRANSPORT_EXPRESS_ROAD,
  MODE_OF_TRANSPORT_RAIL,
  MODE_OF_TRANSPORT_ROAD,
} from 'shared/ncts/common/constants'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0941Validator = {
  validateConsignmentTransportDocumentRequirement: ({
    security,
    specificCircumstanceIndicator,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType: string
    specificCircumstanceIndicator?: string
  }): RuleResult => {
    if (!['1', '3'].includes(security)) {
      return 'OPTIONAL'
    }

    if (
      specificCircumstanceIndicator
      && [MODE_OF_TRANSPORT_ROAD, MODE_OF_TRANSPORT_RAIL].includes(specificCircumstanceIndicator)
    ) {
      return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
    }

    return specificCircumstanceIndicator === MODE_OF_TRANSPORT_EXPRESS_ROAD ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
  validateHouseConsignmentTransportDocumentRequirement: ({
    security,
    specificCircumstanceIndicator,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType: string
    specificCircumstanceIndicator: string
  }): RuleResult => {
    if (!['1', '3'].includes(security)) {
      return 'OPTIONAL'
    }

    if ([MODE_OF_TRANSPORT_ROAD, MODE_OF_TRANSPORT_EXPRESS_ROAD].includes(specificCircumstanceIndicator)) {
      return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
    }

    return specificCircumstanceIndicator === MODE_OF_TRANSPORT_RAIL ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0941Validator
